"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.define-property");

var __importDefault = function __importDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
};

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.PrevNextButton = void 0;

var react_1 = __importDefault(require("react"));

exports.PrevNextButton = function (e) {
  var t = e.name,
      a = e.isDisabled,
      r = e.onClick,
      c = e.renderPrevButton,
      l = e.renderNextButton,
      e = "alice-carousel__" + t + "-btn-item" + (a ? " __inactive" : "");
  return "function" == typeof c ? react_1["default"].createElement("div", {
    className: "alice-carousel__" + t + "-btn",
    onClick: r
  }, c({
    isDisabled: a
  })) : "function" == typeof l ? react_1["default"].createElement("div", {
    className: "alice-carousel__" + t + "-btn",
    onClick: r
  }, l({
    isDisabled: a
  })) : react_1["default"].createElement("div", {
    className: "alice-carousel__" + t + "-btn"
  }, react_1["default"].createElement("div", {
    className: "alice-carousel__" + t + "-btn-wrapper"
  }, react_1["default"].createElement("p", {
    className: e,
    onClick: r
  }, react_1["default"].createElement("span", {
    "data-area": "prev" === t ? "<" : ">"
  }))));
};